import { render, staticRenderFns } from "./ImportarArquivo.vue?vue&type=template&id=451a4115&"
import script from "./ImportarArquivo.vue?vue&type=script&lang=js&"
export * from "./ImportarArquivo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports